(() => {
  if (window.__slidersCarouselInitialized) return;
  window.__slidersCarouselInitialized = true;

  const initializeSlidersCarousel = () => {
    const sliders = document.querySelectorAll(".js-sliders-carousel:not(.active)");

    sliders.forEach((element) => {
      element.classList.add("active");

      const disableAutoHeight = element.classList.contains("sliders");

      const splide = new Splide(element, {
        type: "slide",
        rewind: true,
        gap: "100px",
        arrowPath:
          "M12.744 18.9481C12.5878 19.1044 12.5 19.3163 12.5 19.5373C12.5 19.7582 12.5878 19.9702 12.744 20.1264L17.4582 24.8406C17.6153 24.9924 17.8258 25.0764 18.0443 25.0745C18.2628 25.0726 18.4718 24.9849 18.6263 24.8304C18.7808 24.6759 18.8685 24.4669 18.8704 24.2484C18.8723 24.0299 18.7883 23.8194 18.6365 23.6623L15.3448 20.3706H26.3807C26.6017 20.3706 26.8136 20.2828 26.9699 20.1265C27.1262 19.9702 27.214 19.7583 27.214 19.5373C27.214 19.3162 27.1262 19.1043 26.9699 18.948C26.8136 18.7917 26.6017 18.7039 26.3807 18.7039H15.3448L18.6365 15.4123C18.7883 15.2551 18.8723 15.0446 18.8704 14.8261C18.8685 14.6076 18.7808 14.3986 18.6263 14.2441C18.4718 14.0896 18.2628 14.0019 18.0443 14.0001C17.8258 13.9981 17.6153 14.0821 17.4582 14.2339L12.744 18.9481Z",
      });

      element.__splide = splide;

      const track = element.querySelector(".splide__track");

      if (!disableAutoHeight) {
        const computeTargetHeight = () => {
          const visibles = element.querySelectorAll(".splide__slide.is-visible");
          if (visibles.length > 1) {
            let h = 0;
            visibles.forEach((el) => (h = Math.max(h, el.offsetHeight)));
            return h;
          }
          const Slides = splide.Components?.Slides;
          const active =
            Slides?.getAt(splide.index)?.slide ||
            element.querySelector(".splide__slide.is-active");
          return active ? active.offsetHeight : track.offsetHeight || 0;
        };

        const setTrackHeight = (h, animate = true) => {
          if (!track) return;
          if (!animate) track.classList.add("no-anim");
          track.style.height = h ? `${h}px` : "";
          if (!animate) {
            void track.offsetHeight;
            track.classList.remove("no-anim");
          }
        };

        const updateHeight = (animate = true) => {
          requestAnimationFrame(() => {
            requestAnimationFrame(() => {
              const h = computeTargetHeight();
              if (h) setTrackHeight(h, animate);
            });
          });
        };

        splide.on("mounted", () => updateHeight(false));
        splide.on("moved", () => updateHeight(true));
        splide.on("resized refreshed", () => updateHeight(false));
        splide.on("lazyload:loaded", () => updateHeight(true));

        window.addEventListener("load", () => updateHeight(true));

        element.querySelectorAll("img").forEach((img) => {
          if (!img.complete) {
            img.addEventListener("load", () => updateHeight(true), { once: true });
            img.addEventListener("error", () => updateHeight(true), { once: true });
          }
        });

        splide.on("move", (newIndex) => {
          const Slides = splide.Components?.Slides;
          const destSlide = Slides?.getAt(newIndex)?.slide;
          const h = destSlide?.offsetHeight || computeTargetHeight();
          if (h) setTrackHeight(h, true);
        });
      }

      splide.mount();

      const tabsContainer = element.closest(".js-tabs");
      const navItems = tabsContainer
        ? Array.from(tabsContainer.querySelectorAll(".js-tabs-nav-item"))
        : [];

      const setActiveTab = (zeroBasedIndex) => {
        if (!tabsContainer || !navItems.length) return;
        const oneBased = zeroBasedIndex + 1;
        navItems.forEach((el) => {
          const idx = parseInt(el.getAttribute("data-index"), 10);
          el.classList.toggle("active", idx === oneBased);
        });
      };

      if (tabsContainer) {
        tabsContainer.addEventListener("click", (e) => {
          const tabItem = e.target.closest(".js-tabs-nav-item");
          if (!tabItem) return;
          const index =
            Math.max(0, (parseInt(tabItem.getAttribute("data-index"), 10) || 1) - 1);
          splide.go(index);
          setActiveTab(index);
          e.preventDefault();
        });
      }

      splide.on("mounted", () => setActiveTab(splide.index));
      splide.on("move", (newIndex) => setActiveTab(newIndex));
      splide.on("resized refreshed", () => setActiveTab(splide.index));
    });
  };

  document.addEventListener("DOMContentLoaded", initializeSlidersCarousel);
  document.addEventListener("shopify:section:load", initializeSlidersCarousel);
  document.addEventListener("shopify:section:reorder", initializeSlidersCarousel);
  document.addEventListener("shopify:section:select", initializeSlidersCarousel);
  document.addEventListener("shopify:block:select", initializeSlidersCarousel);
  document.addEventListener("shopify:block:deselect", initializeSlidersCarousel);

  document.addEventListener("shopify:block:select", (event) => {
    const blockId = event.detail.blockId;
    if (!blockId) return;

    let block =
      document.querySelector('[data-block-id="' + blockId + '"]') ||
      document.getElementById("shopify-block-" + blockId) ||
      document.getElementById(blockId);

    if (!block) return;

    const slide = block.closest(".splide__slide");
    if (!slide) return;

    const slider = slide.closest(".js-sliders-carousel");
    if (!slider) return;

    const splide = slider.__splide || slider.splide;
    if (!splide) return;

    const slides = Array.from(slider.querySelectorAll(".splide__slide"));
    const index = slides.indexOf(slide);
    if (index === -1) return;

    splide.go(index);

    const tabsContainer = slider.closest(".js-tabs");
    if (tabsContainer) {
      const navItems = Array.from(
        tabsContainer.querySelectorAll(".js-tabs-nav-item")
      );
      const oneBased = index + 1;
      navItems.forEach((el) => {
        const idx = parseInt(el.getAttribute("data-index"), 10);
        el.classList.toggle("active", idx === oneBased);
      });
    }
  });
})();